<div
    class="cell-content"
    [ngClass]="row | avmFolderWorkflowCellPipe: column : WorkflowStepPropertyCodes.COMPLETED"
    [class.date-hidden]="!isWorkflowStepDateVisible"
    [class.date-visible]="isWorkflowStepDateVisible"
    [hubComponentTooltip]="TooltipWorkflowStepComponent"
    [tooltipPosition]="'bottom'"
    [tooltipData]="workflowStepsSnapshot">
    <span [ngClass]="{ unread: !row.isRead }">
        {{ row | avmFolderWorkflowCellPipe: column : WorkflowStepPropertyCodes.STATE }}
    </span>
    @if (isWorkflowStepDateVisible) {
        <span class="date" [ngClass]="{ unread: !row.isRead }" [title]="row | avmFolderWorkflowCellPipe: column : WorkflowStepPropertyCodes.DATE">
            {{ row | avmFolderWorkflowCellPipe: column : WorkflowStepPropertyCodes.DATE }}
        </span>
    }
</div>
